import JourneyOfferList from '@/components/purchase/journey/JourneyOfferList';
import {
  setSelectedInboundOfferMapByLegId,
  updateSelectedInboundOfferMapByLegId,
} from '@/features/purchase/purchaseActions';
import {
  inboundDataSelector,
  selectedInboundOfferMapSelector,
} from '@/features/purchase/purchaseSelectors';
import { useBookingCreation } from '@/hooks/useBookingCreation';
import { TransText } from '@/i18n/trans/text';
import { useDispatch, useSelector } from '@/store/utils';
import { getDefaultOfferMap } from '@/utils/purchase';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const InboundJourneyOfferList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inboundData = useSelector(inboundDataSelector);
  const { handleCreatingAndFetchingTripOfferBooking } = useBookingCreation();

  useEffect(() => {
    if (inboundData.selectedJourney) {
      dispatch(
        setSelectedInboundOfferMapByLegId(
          getDefaultOfferMap(inboundData.selectedJourney)
        )
      );
    }
  }, [dispatch, inboundData.selectedJourney]);

  useEffect(() => {
    if (!inboundData.selectedJourney) {
      navigate('/purchase');
    }
  }, [navigate, inboundData.selectedJourney]);

  return (
    <JourneyOfferList
      title={<TransText i18nKey="selectReturnTicket" />}
      selectedJourney={inboundData.selectedJourney}
      updateSelectedOfferMap={updateSelectedInboundOfferMapByLegId}
      selectedOfferMapByLegIdSelector={selectedInboundOfferMapSelector}
      onContinue={handleCreatingAndFetchingTripOfferBooking}
      onGoBack={() => navigate(-1)}
    />
  );
};

export default InboundJourneyOfferList;
